<template>
  <span>
    <span v-b-tooltip.hover :title="tipoStatus[pin].title" :class="`badge ${tipoStatus[pin].class}`">
      <font-awesome-icon v-if="tipoStatus[pin].icon" :icon="`fa-solid fa-${tipoStatus[pin].icon}`" />
      {{ tipoStatus[pin].title }}
    </span>
  </span>
</template>

<script>
export default {
  props: ['pin'],
  data() {
    return {
      tipoStatus: {
        1: { title: this.$i18n.t('Pendente'), class: 'badge-outline-primary', icon: null },
        2: { title: this.$i18n.t('Impresso'), class: 'badge-outline-danger', icon: null },
        3: { title: this.$i18n.t('Não Impresso'), class: 'badge-outline-success', icon: null },
        4: { title: this.$i18n.t('Negado'), class: 'badge-outline-danger', icon: null },
        5: { title: this.$i18n.t('Pendente'), class: 'badge-outline-warning', icon: null },
        6: { title: this.$i18n.t('Antecipado'), class: 'badge-outline-info', icon: null },
        7: { title: this.$i18n.t('Efetivado'), class: 'badge-outline-success', icon: null }
      }
    };
  }
};
</script>

<style lang="scss" scoped></style>
